<template>
  <button :class="type" :style="{ 'font-size': fontSize, 'height': height, 'width': width, 'border-radius': borderRadius, 'fontWeight': fontWeight }"
          @click="onClick"
          :disabled="disabled || isLoading"
  >
    <slot v-if="!isLoading" />
    <v-load-spinner
      v-if="isLoading"
      :is-loading="isLoading"
    />
  </button>
</template>

<script>
import VLoadSpinner from './VLoadSpinner.vue'

export default {
  name: 'VButton',
  components: { VLoadSpinner },
  props: {
    onClick: {
      type: Function,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    },
    height: {
      type: String,
      default: '40px'
    },
    width: {
      type: String,
      default: 'auto'
    },
    fontSize: {
      type: String,
      default: '14px'
    },
    borderRadius: {
      type: String,
      default: '5px'
    },
    fontWeight: {
      type: String,
      default: '600'
    }
  }
}
</script>

<style scoped lang="scss">
button {
    border-radius: 3px;
    padding: 0 12px;
    //font-family: OpenSans-Semibold, sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    text-align: center;
    cursor: pointer;
    transition: .2s ease-in-out 0s;
    &.primary {
      background: $primary-color;
      color: #FFFFFF;
      border: none;
      &:hover, &:focus {
        background: color.adjust( $primary-color, $lightness: 16% );
      }
      &:active {
        background: color.adjust( $primary-color, $lightness: 20% )
      }
    }

  &.close {
    font-weight: 600;
    display: inline-block;
    background:#9B9B9B;
    background: rgba(160, 81, 81, 1);
    color: white;
    border: none;
    margin-right: 5px;

    &.dark {
      background-color: rgba(100,100,100, 0.8)
    }

    &:hover:enabled, &:focus:enabled {
      background: color.adjust(rgba(180, 81, 81, 1), $lightness: 10%);
      &.dark {
        background-color: rgba(100,100,100,0.95);
      }
    }

    &:active {
      background: color.adjust(rgba(210, 30, 30, 0.7), $lightness: 10%);
    }

    &.tilted-45 {
      transform: rotate(45deg) !important;
      padding: 0;
    }
  }

  &.tertiary {
    background: rgba( 50,0,0,0.6);
    color: #FFFFFF;
    border: none;
    &:hover, &:focus {
      background: color.adjust( $primary-color, $lightness: 5% );
    }
    &:active {
      background: color.adjust( $primary-color, $lightness: 10% )
    }
  }
    &.secondary {
        background-color: white;
        border: 1px solid $primary-color;
        color: $primary-color;
      &:hover {
        color: white;
        background-color: $primary-color;
      }
    }
    &:disabled, &:disabled:hover {
      background:#9B9B9B;
      opacity: 0.3;
      box-shadow: none;
      transform: none;
      cursor: default;
    }
}
</style>
